<template>
  <div style="margin-bottom: 20px;" class="datepicker-container">
    <label class="label date_of_birth_label" style="">&nbsp;Date of Birth</label>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">&nbsp;Month</label>
          <div class="control">
            <div
              class="select"
              :class="field.error ? 'is-danger' : ''"
              style="width: 100%; height: 42px;"
            >
              <select
                v-model="inputs.month"
                style="width: 100%;  -webkit-box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); border-radius: 2px; padding-left: 15px; height: 42px;"
                @change="modified"
              >
                <option v-for="(option, idx) in monthOptions" v-bind:key="option" :value="idx+1">{{option}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Day</label>
          <div class="control">
            <div
              class="select"
              :class="field.error ? 'is-danger' : ''"
              style="width: 100%; height: 42px;"
            >
              <select
                v-model="inputs.day"
                style="width: 100%;  -webkit-box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); border-radius: 2px; padding-left: 15px; height: 42px;"
                @change="modified"
              >
                <option v-for="option in days" v-bind:key="option">{{option}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column year_column">
        <div class="field">
          <label class="label">Year</label>
          <div class="control">
            <div
              class="select"
              :class="field.error ? 'is-danger' : ''"
              style="width: 100%; height: 42px;"
            >
              <select
                v-model="inputs.year"
                style="width: 100%;  -webkit-box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); border-radius: 2px; padding-left: 15px; height: 42px;"
                @change="modified"
              >
                <option v-for="option in years" v-bind:key="option">{{option}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="help is-danger" v-if="field.error">{{field.error}}</p>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "DatePicker",
  model() {
    return { value: "", error: "", typed: false };
  },
  props: {
    inputField: Object,
    inputName: String,
    inputType: String,
    options: Array
  },
  data() {
    return {
      field: this.inputField,
      monthOptions: moment.months(),
      inputs: {
        month: "",
        day: "",
        year: ""
      }
    };
  },
  computed: {
    days: function() {
      var arr = [];
      let max = 31
      if (this.inputs.month){
        max = moment("2012-"+this.inputs.month, "YYYY-MM").daysInMonth()
      }
      for (var i = 1; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    years: function() {
      var arr = [];
      var date = new Date();
      for (var i = date.getFullYear() - 20; i >= 1900; i--) {
        arr.push(i);
      }
      return arr;
    }
  },
  methods: {
    modified() {
      const { month, day, year } = this.inputs;
      const date = moment(`${month}/${day}/${year}`, "M/D/YYYY", true);

      this.field.value = date.isValid() ? date.format("YYYY-MM-DD") : "";
      this.validate();
    },
    validate() {
      const { month, day, year } = this.inputs;
      const isValid =
        this.field.value &&
        month &&
        day &&
        year &&
        moment(this.field.value, "YYYY-MM-DD", true).isValid();
      this.field.error = isValid ? null : "Please enter a valid date";
      return isValid;
    },
    setValue(s) {
      this.field.value = s;
      this.modified();
    }
  }
};
</script>
<style scoped>
.column{
  padding-right: 12px;
  padding-bottom: 0;
}
.columns{
  display: ruby;
}
.datepicker-container{
  /* background: rgb(246, 246, 246); */
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
  padding-left: 5px;
}
.year_column{
  padding-right: 0;
}
.date_of_birth_label{
  font-weight: bold;
  margin-bottom: 0px;
  font-size: 1rem;

  color: #666;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.label{
  color: #A5A5A5;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.select:not(.is-multiple):not(.is-loading)::after{
    border-color: #A5A5A5;
}
@media (max-width: 47.999em) {
  .column{
    width: 100%;
  }
  .year_column{
    padding-right: 12px;
  }
}
</style>